import React, { useState, useCallback } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { StyledWorksWrapper, WorksTitle } from "../Styled"
import { LightBox } from "../../LightBox/LightBox"
import {
  Ui001cb,
  Ui002ango,
  Ui003lbox,
  Ui004hr1,
  Ui005hr2,
  Ui006vicons,
  Ui007trailway,
  Ui008rng,
  Gra001ntnu,
  Gra002bawan,
  Gra003prism,
  Gra004sdumpling,
  Ser001annualreport2017,
  Td001bsdadi,
  Td0023dvicons,
  Ui009zotter,
} from "./"

const titles = [
  "Cheese Burger - Best Platform for Designers",
  "ANGO - Perfect Place for Trading Cars ",
  "Job Portal Website Design",
  "Talents Recruiting Website",
  "Vital Icon System",
  "Taiwan Railway APP Redesign",
  "Beijing Meet RNG - A H5 Design",
  "Lunch Box - Best Tool for Everyday Lunch",
  "Visual Identity of NTNU Club Leader Camp",
  "Visual System of Bawan Sheng",
  "Infographic of Steamed Dumpling",
  "Prism - The Poster",
  "Service Design Annual Report 2017",
  "Cultural Design of Baosheng Dadi",
  "3D version of Vital Products’ Icons",
  "Zotter and Chocolate Adventure - A H5 Design",
]
const order = [
  "ui_001_cb",
  "ui_002_ango",
  "ui_004_hr1",
  "ui_005_hr2",
  "ui_006_vicons",
  "ui_007_trailway",
  "ui_008_rng",
  "ui_003_lbox",
  "gra_001_ntnu",
  "gra_002_bawan",
  "gra_004_sdumpling",
  "gra_003_prism",
  "ser_001_annualreport2017",
  "td_001_bsdadi",
  "td_002_3dvicons",
  "ui_009_zotter",
]
export const Covers = () => {
  const [isShow, setIsShow] = useState(false)
  const [currentWork, setCurrentWorks] = useState("")
  const showWorks = useCallback(work => {
    setIsShow(true)
    setCurrentWorks(work)
  }, [])
  const newPage = useCallback(url => {
    window.open(url, "_blank")
  }, [])
  const data = useStaticQuery(graphql`
    query {
      placeholderImage1: file(relativePath: { eq: "ui_001_cb/000_cover.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage2: file(
        relativePath: { eq: "ui_002_ango/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage3: file(
        relativePath: { eq: "ui_004_hr1/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage4: file(
        relativePath: { eq: "ui_005_hr2/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage5: file(
        relativePath: { eq: "ui_006_vicons/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage6: file(
        relativePath: { eq: "ui_007_trailway/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage7: file(
        relativePath: { eq: "ui_008_rng/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage8: file(
        relativePath: { eq: "ui_003_lbox/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage9: file(
        relativePath: { eq: "gra_001_ntnu/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage10: file(
        relativePath: { eq: "gra_002_bawan/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage11: file(
        relativePath: { eq: "gra_004_sdumpling/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage12: file(
        relativePath: { eq: "gra_003_prism/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage13: file(
        relativePath: { eq: "ser_001_annualreport2017/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage14: file(
        relativePath: { eq: "td_001_bsdadi/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage15: file(
        relativePath: { eq: "td_002_3dvicons/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage16: file(
        relativePath: { eq: "ui_009_zotter/000_cover.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <StyledWorksWrapper onClick={() => showWorks(titles[0])}>
        <Img fluid={data.placeholderImage1.childImageSharp.fluid} />
        <WorksTitle>{titles[0]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[1])}>
        <Img fluid={data.placeholderImage2.childImageSharp.fluid} />
        <WorksTitle>{titles[1]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[2])}>
        <Img fluid={data.placeholderImage3.childImageSharp.fluid} />
        <WorksTitle>{titles[2]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[3])}>
        <Img fluid={data.placeholderImage4.childImageSharp.fluid} />
        <WorksTitle>{titles[3]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[4])}>
        <Img fluid={data.placeholderImage5.childImageSharp.fluid} />
        <WorksTitle>{titles[4]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[5])}>
        <Img fluid={data.placeholderImage6.childImageSharp.fluid} />
        <WorksTitle>{titles[5]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[6])}>
        <Img fluid={data.placeholderImage7.childImageSharp.fluid} />
        <WorksTitle>{titles[6]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[7])}>
        <Img fluid={data.placeholderImage8.childImageSharp.fluid} />
        <WorksTitle>{titles[7]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[8])}>
        <Img fluid={data.placeholderImage9.childImageSharp.fluid} />
        <WorksTitle>{titles[8]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[9])}>
        <Img fluid={data.placeholderImage10.childImageSharp.fluid} />
        <WorksTitle>{titles[9]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[10])}>
        <Img fluid={data.placeholderImage11.childImageSharp.fluid} />
        <WorksTitle>{titles[10]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[11])}>
        <Img fluid={data.placeholderImage12.childImageSharp.fluid} />
        <WorksTitle>{titles[11]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper
        onClick={() =>
          newPage(
            `https://drive.google.com/file/d/17JB9PeiBKk6mKnsBK0ywGdZSqZiO9bQp/view`
          )
        }
      >
        <Img fluid={data.placeholderImage13.childImageSharp.fluid} />
        <WorksTitle>{titles[12]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[13])}>
        <Img fluid={data.placeholderImage14.childImageSharp.fluid} />
        <WorksTitle>{titles[13]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => showWorks(titles[14])}>
        <Img fluid={data.placeholderImage15.childImageSharp.fluid} />
        <WorksTitle>{titles[14]}</WorksTitle>
      </StyledWorksWrapper>
      <StyledWorksWrapper onClick={() => newPage(`http://h5.in-sfc.com`)}>
        <Img fluid={data.placeholderImage16.childImageSharp.fluid} />
        <WorksTitle>{titles[15]}</WorksTitle>
      </StyledWorksWrapper>
      {isShow && (
        <LightBox
          onClose={() => {
            setIsShow(false)
          }}
          title={currentWork}
        >
          {currentWork === titles[0] && <Ui001cb />}
          {currentWork === titles[1] && <Ui002ango />}
          {currentWork === titles[2] && <Ui004hr1 />}
          {currentWork === titles[3] && <Ui005hr2 />}
          {currentWork === titles[4] && <Ui006vicons />}
          {currentWork === titles[5] && <Ui007trailway />}
          {currentWork === titles[6] && <Ui008rng />}
          {currentWork === titles[7] && <Ui003lbox />}
          {currentWork === titles[8] && <Gra001ntnu />}
          {currentWork === titles[9] && <Gra002bawan />}
          {currentWork === titles[10] && <Gra004sdumpling />}
          {currentWork === titles[11] && <Gra003prism />}
          {currentWork === titles[12] && <Ser001annualreport2017 />}
          {currentWork === titles[13] && <Td001bsdadi />}
          {currentWork === titles[14] && <Td0023dvicons />}
          {currentWork === titles[15] && <Ui009zotter />}
        </LightBox>
      )}
    </>
  )
}
